import { BadgeCheck, Crown, Star, Store } from 'lucide-react';

/**
 * Renders user badges inline. Pass the user/seller object directly.
 * Props: is_verified, badge_founder, badge_super_seller, badge_local_business
 * Or prefixed: seller_is_verified, seller_badge_founder, etc.
 */
export default function UserBadges({ user = {}, size = 'sm', prefix = '' }) {
  const get = (key) => user[`${prefix}${key}`];

  const badges = [];

  if (get('is_verified')) {
    badges.push({ key: 'verified', icon: BadgeCheck, color: '#3b82f6', label: 'Verificado' });
  }
  if (get('badge_founder')) {
    badges.push({ key: 'founder', icon: Crown, color: '#f5c518', label: 'Fundador' });
  }
  if (get('badge_super_seller')) {
    badges.push({ key: 'super', icon: Star, color: '#a855f7', label: 'Super Vendedor' });
  }
  if (get('badge_local_business')) {
    badges.push({ key: 'business', icon: Store, color: '#22c55e', label: 'Negocio Local' });
  }

  if (badges.length === 0) return null;

  const iconSize = size === 'sm' ? 'w-3.5 h-3.5' : 'w-4 h-4';

  return (
    <span data-testid="user-badges" className="inline-flex items-center flex-wrap gap-1">
      {badges.map(b => (
        <span key={b.key} data-testid={`badge-${b.key}`} title={b.label}>
          <b.icon className={iconSize} style={{ color: b.color }} />
        </span>
      ))}
    </span>
  );
}
